import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummaryDebt({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [activeTable, setActiveTable] = useState('client')

	async function searchWithFilter(type = 'client') {
		var filterUrl = ""
		var urlParams = ""

		if (type === 'client') {
			filterUrl = "/report-summary-debt-clients"
		}
		if (type === 'organization') {
			filterUrl = "/report-summary-debt-organizations"
		}

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="md"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('debt')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '70%' }}>
										{activeTable === 'client' &&
											<span className="text-primary cursor table-first-column-clickable"
												onClick={() => {
													if (activeTable === 'client') {
														setActiveTable('organization')
														searchWithFilter('organization')
													}
													if (activeTable === 'organization') {
														setActiveTable('client')
														searchWithFilter('client')
													}
												}}>
												{t('client')}
											</span>
										}
										{activeTable === 'organization' &&
											<span className="text-primary cursor table-first-column-clickable"
												onClick={() => {
													if (activeTable === 'client') {
														setActiveTable('organization')
														searchWithFilter('organization')
													}
													if (activeTable === 'organization') {
														setActiveTable('client')
														searchWithFilter('client')
													}
												}}>
												{t('organization')}
											</span>
										}
									</th>
									<th className="text-end" style={{ 'width': '30%' }}>{t('debt')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td className="text-danger text-end">{formatMoney(item.amount)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-danger text-end"><b>{formatMoney(data.total_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummaryDebt